import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const FeeReportsLazy = React.lazy(
	() => import(/* webpackChunkName : 'FeeReportsLazy' */ './components')
);

export default (store) => [
	{
		path: 'home/fees/fee-dashboard/fee-reports',
		element: <AsyncLoading component={<FeeReportsLazy />} />,
	},
];
